import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index'

Vue.use(Router)
const orgins =[
  {
    path:'/applicationTool-fxcx',
    component:()=>import('@/views/applicationTool/applicationTool-fxcx'),//企业中心-专项自查 前
    name:'applicationTool-fxcx',
    linkActiveClass:'active'
}
]

export default orgins



// WEBPACK FOOTER //
// ./src/router/origns.js